module.exports = __webpack_public_path__ + "img/noticias-cel.77b34aaf.png";